import { Listener } from './Listener';
import { setCookie } from '../../helpers/cookies';
import { extractDomainParts, shiftSubdomain } from '../../helpers/extract-domain';
export class CookiesListener extends Listener {
    setConsent(eventId, essential, functional, marketing) {
        if (!essential) {
            return;
        }
        setCookie('consent', JSON.stringify({ essential, functional, marketing }), {
            path: '/',
            domain: shiftSubdomain(extractDomainParts(window.location.hostname)),
        });
    }
}
